import React from "react";
import moment from "moment";
import PAGE_CONSTANTS from "../constant";
import CONSTANTS from "../../../../Utils/constant";
const addressRegex = /^[a-zA-Z0-9\s.,#()\\\-\/]+$/;
const cityRegex = /^[a-zA-Z\s]+$/;
const mobileRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
const emailRegex = /[A-Za-z0-9\._%+\-]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,}$/;

export const validateEmail =
  (email, handleError) => (rule, value, callback) => {
    let error = "";
    if (!email) {
      error = "Email is required";
      callback(error);
    } else if (!emailRegex.test(email)) {
      error = "Invalid email address";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ email: error });
  };

export const validateMobile =
  (mobile, handleError) => (rule, value, callback) => {
    let error = "";
    if (!mobile) {
      error = "Mobile is required";
      callback(error);
    } else if (!mobileRegex.test(mobile)) {
      error = "Invalid mobile";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ mobile: error });
  };

  export const validateHomePincode = (homePincode, handleError) => (rule, value, callback) => {
    let error = "";
    if (!homePincode) {
      error = "Pincode is required";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ homePincode: error });
};

  export const validateCity = (city, handleError) => (rule, value, callback) => {
    let error = "";
    if (!city) {
      error = "City is required";
      callback(error);
    } else if (!cityRegex.test(city)) {
      error = "Invalid city";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ city: error });
};

export const validateAddressLine1 = (address, handleError) => (rule, value, callback) => {
    let error = "";
    if (!address) {
      error = "Address is required";
      callback(error);
    } else if (!addressRegex.test(address)) {
      error = "Invalid address";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ addressLine1: error });
};

export const validateAddressLine2 = (address, handleError) => (rule, value, callback) => {
    let error = "";
     if(address && !addressRegex.test(address)) {
      error = "Invalid address";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ addressLine2: error });
};

export const validateLandmark = (landmark, handleError) => (rule, value, callback) => {
    let error = "";
    if (landmark && !addressRegex.test(landmark)) {
      error = "Invalid landmark";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ landmark: error });
};

export const validateAppointmentDate =
  (date, handleError) => (rule, value, callback) => {
    let error = "";
    if (!date) {
      error = "Date is required";
      callback(error);
    } else {
      error = "";
      callback();
    }
    handleError({ appointmentDate: error });
  };

export const pickerOptionsMinutes = (isLastHour = false, count = 2, startFrom = 30) => {
  const arrayValues = Array.from(Array(count), (_, i) => i * startFrom);
  if(isLastHour){
    return (
      <option key={`0`} value={`00`}>
        {`00`}
      </option>
    )
  }
  return arrayValues.map((src, index) => {
    const optionValue = src < 10 ? `0${src}` : `${src}`;
    return (
      <option key={count + src + index} value={optionValue}>
        {optionValue}
      </option>
    );
  });
};

export const getCurrentMeridiem = () => {
  const currentHour = moment().toDate().getHours();
  return currentHour >= 12 ? 'PM' : 'AM';
}

export const isSameDateSelected = (date) => {
  return date === moment().format(CONSTANTS?.FORMAT_DOB)
}

export const getRoundHourForTele = () => {
  const currentMinute = moment().toDate().getMinutes();
  const currentHour = moment().toDate().getHours();
  if(currentMinute > 0){
    return currentHour + 1;
  }
  else{
    return currentHour;
  }
}

export const getAllowedStartingHour = (bufferHours) => {
  const roundedHour = getRoundHourForTele();
  const allowedStartingHour = roundedHour + bufferHours;
  if(allowedStartingHour >= 12 && allowedStartingHour < 24){
    return {
      hour: allowedStartingHour > 12 ? allowedStartingHour - 12 : allowedStartingHour,
      meridiem: PAGE_CONSTANTS?.MERIDIEM_PM
    }
  }
  else{
    return {
      hour: allowedStartingHour >= 24 ? allowedStartingHour - 24 : allowedStartingHour,
      meridiem: PAGE_CONSTANTS?.MERIDIEM_AM
    }
  }
}
export const pickerOptionsHours = (selectedMeridiem, bufferHours, isSameDate = false) => {

  const arrayValues =
  selectedMeridiem === PAGE_CONSTANTS?.MERIDIEM_AM
    ? PAGE_CONSTANTS?.TELE_TIME_CONFIG?.AM
    : PAGE_CONSTANTS?.TELE_TIME_CONFIG?.PM;
  const allowed = getAllowedStartingHour(bufferHours);
  //RETURN FILTERED TYPE; => IF SAME DATE AND SELECTED AND ALLOWED MERIDIEM IS SAME
  if(isSameDate && allowed?.meridiem === selectedMeridiem){
    const arrayValuesForSameDate =
    allowed?.meridiem === PAGE_CONSTANTS?.MERIDIEM_AM
      ? PAGE_CONSTANTS?.TELE_TIME_CONFIG?.AM
      : PAGE_CONSTANTS?.TELE_TIME_CONFIG?.PM;

    if(allowed?.meridiem === PAGE_CONSTANTS?.MERIDIEM_AM){
      return arrayValuesForSameDate?.filter((item) => item >= allowed?.hour);
    }
    else if(allowed?.meridiem === PAGE_CONSTANTS?.MERIDIEM_PM){
      const findHourIndex = arrayValuesForSameDate?.findIndex((item) => item == allowed?.hour);
      return (findHourIndex !== -1) ? arrayValuesForSameDate?.slice(findHourIndex, arrayValuesForSameDate?.length) : [];
    }
  }
  //RETURN SELECTED MERIDIEM TYPE;
  else{
    return arrayValues;
  }
};

export const getMinDate = (bufferHours) => {
  const currentHour = moment().toDate().getHours();
  const addDays = (currentHour + bufferHours) < 20 ? 0 : 1;
  if(addDays !== 0){
    return moment().add(addDays,'days').toDate();
  }
  else{
    return moment().toDate();
  }
}

export const getMaxDate = (bufferHours) => {
  const currentHour = moment().toDate().getHours();
  const addDays = (currentHour + bufferHours) < 20 ? 7 : 8;
    if(moment().add(addDays,'days')?.day() === 0){
      return moment().add(addDays + 1,'days').toDate();
    }
    else{
      return moment().add(addDays,'days').toDate();
    }
}